var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 15.8333C14.341 15.8333 15.8334 14.3409 15.8334 12.5C15.8334 10.659 14.341 9.16666 12.5001 9.16666C10.6591 9.16666 9.16675 10.659 9.16675 12.5C9.16675 14.3409 10.6591 15.8333 12.5001 15.8333Z",
    fill: "#3B3B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37492 2.08334L7.46867 4.16668H4.16659C3.02075 4.16668 2.08325 5.10418 2.08325 6.25001V18.75C2.08325 19.8958 3.02075 20.8333 4.16659 20.8333H20.8333C21.9791 20.8333 22.9166 19.8958 22.9166 18.75V6.25001C22.9166 5.10418 21.9791 4.16668 20.8333 4.16668H17.5312L15.6249 2.08334H9.37492ZM12.4999 17.7083C9.62492 17.7083 7.29158 15.375 7.29158 12.5C7.29158 9.62501 9.62492 7.29168 12.4999 7.29168C15.3749 7.29168 17.7083 9.62501 17.7083 12.5C17.7083 15.375 15.3749 17.7083 12.4999 17.7083Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraAlt);
export default __webpack_public_path__ + "static/media/camera-alt.1db08b9eab1f3dd73f707a6f9ef422f8.svg";
export { ForwardRef as ReactComponent };